export default {"src":"/_next/static/media/NoticeMegaphone.24347c78.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};